<div class="l-loading text-center">
	<div class="wrapper">
		<svg width="1em" class="text-primary svg-xl" viewBox="0 0 384 512" aria-hidden="true" focusable="false">
			<use xlink:href="@Assets/svg/symbol-defs.svg#question"/>
		</svg>
		<p>
			<strong class="text-lg text-primary">{{ $t('vm.root.help.home-help.title') }}</strong>
		</p>
		<help-alert id="support-help3">
			<div class="notice-info">
				<p class="text-left">
					<svg width="1em" class="svg-middle" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
						<use xlink:href="@Assets/svg/symbol-defs.svg#question-circle"/>
					</svg>
					<i18n path="vm.root.help.home-help.text" tag="span">
						<a href="//support.osteo2ls.com/" target="_blank" :title="$t('vm.root.help.home-help.link-title1')">
							<strong>{{ $t('vm.root.help.home-help.link-label1') }}</strong>
						</a>
						<a href="//support.osteo2ls.com/User/LostPassword" target="_blank" :title="$t('vm.root.help.home-help.link-title2')">
							<strong>{{ $t('vm.root.help.home-help.link-label2') }}</strong>
						</a>
					</i18n>
				</p>
			</div>
		</help-alert>
		<br>
		<help-alert id="support-help1" v-if="!isJitbitAccountSynchronized">
			<div class="notice-danger">
					<p class="text-left">
						<svg width="1em" class="svg-middle" viewBox="0 0 576 512" aria-hidden="true">
							<use xlink:href="@Assets/svg/symbol-defs.svg#exclamation-triangle" />
						</svg>
						{{ $t("vm.root.help.home-help.no-support-account.text")}}
					</p>
					<footer class="text-center">
						<button-action
							@click.native="createJitBitAccount" :loading="isCreatingJitbit" :disabled="isCreatingJitbit"
							:btn-class="['btn btn-primary']"
							:title="$t('vm.root.help.home-help.no-support-account.link-title')">
							<strong>{{ $t('vm.root.help.home-help.no-support-account.link-label') }}</strong>
						</button-action>
					</footer>
			</div>
		</help-alert>
		<help-alert id="support-help2" v-else>
			<div class="notice-success">
				<p class="text-left">
					<svg width="1em" class="svg-middle" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
						<use xlink:href="@Assets/svg/symbol-defs.svg#check"/>
					</svg>
					{{ $t("vm.root.help.home-help.support-account.text")}}
				</p>
				<footer class="text-center">
					<button-action
						@click.native="goToHelp2ls"
						:btn-class="['btn btn-primary']"
						:title="$t('vm.root.help.home-help.go-help2ls.title')">
						<strong>{{ $t('vm.root.help.home-help.go-help2ls.label') }}</strong>
					</button-action>
					<p>
						<a
							href="#"
							@click.prevent="resetPasswordHelp2ls"
							class="text-decoration-underline"
							:title="$t('vm.root.help.home-help.forgot-password-help2ls.title')"
						>
							{{ $t('vm.root.help.home-help.forgot-password-help2ls.label') }}
						</a>
					</p>

				</footer>
			</div>
		</help-alert>
		<br>
		<i18n path="vm.root.help.home-help.group-fb" tag="p">
			<a href="//facebook.com/groups/198195551042934/" target="_blank" :title="$t('vm.root.help.home-help.link-title')">
				{{ $t('vm.root.help.home-help.link-label') }}
			</a>
		</i18n>
	</div>
</div>
